<template>
  <nav>
    <v-dialog
      v-model="dialog"
      data-testid="target-group-edit-dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      persistent
    >
      <template v-slot:activator="{ on, attrs }">
        <span
          data-testid="edit-name-text"
          v-bind="attrs"
          v-on="on"
          @click="$emit('proceedSubmit', '', '', targetGroupName, '')"
        >{{ $t('edit') }}</span>
      </template>
      <v-card data-testid="edit-target-group-card">
        <v-form
          ref="form"
          v-model="valid"
          @submit.prevent
        >
          <v-toolbar
            dark
            color="accent"
          >
            <v-btn
              data-testid="close-button"
              icon
              dark
              @click="onDialogClose"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title class="text-h5 font-weight-bold">
              {{ $t('editTargetGroupTitle') }}
            </v-toolbar-title>
            <v-spacer />
            <v-btn
              data-testid="submit-button"
              type="submit"
              :disabled="loading"
              color="white"
              class="text-body-1 darktext--text text-none rounded-xxl px-4"
              @click="updateTargetGroup"
            >
              {{ $t('save') }}
            </v-btn>
          </v-toolbar>
          <AlertMessages
            v-if="alertValue"
            alert-type="error" 
            :alert-msg="alertMsg"
            @reset="alertValue = false"
          />
          <v-card-text class="pt-0 pl-6">
            <v-row>
              <v-col
                cols="12"
                md="6"
              >
                <div class="py-15 px-md-12">
                  <!-- <AlertMessages v-if="alertValue"
                                    alertType="error" 
                                    :alertMsg="alertMsg"
                                    @reset="alertValue = false"
                                ></AlertMessages> -->
                  <p class="font-weight-bold text-h6 darktext--text">
                    {{ $t('labelName') }}
                  </p>
                  <v-text-field
                    v-model="name"
                    data-testid="target-group-name-input"
                    solo
                    hide-details="auto"
                    elevation="6"
                    class="rounded-xxl text-body-2 mb-5"
                    :rules="targetGroupNameRules"
                  />
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-form>
      </v-card>
    </v-dialog>
  </nav>
</template>
<script>
import i18n from '../../plugins/i18n'
import { updateTargetGroup } from '../../api/targetGroupApi'
import { ruleValidMin2Max70Characters, ruleRequired } from '../../rules/formRules.js';
import AlertMessages  from '../../components/AlertMessages'

export default {
    components: {
        AlertMessages
    },
    props: {
        targetGroupName: {
          type: String,
          default: ''
        },
        targetGroupId: {
          type: String,
          default: ''
        },
        targetGroupIndex: {
          type: Number,
          default: 0
        },
    },
    data(){
        return{
            dialog: false,
            valid: true,
            alertMsg: '',
            alertValue:false,
            spaceId: window.$cookies.get('space_id'),
            loading: false,
            targetGroupNameRules: ruleRequired('labelName').concat(ruleValidMin2Max70Characters('labelName')),
            val: ''
         }
    },
    computed: {
        name:
        {
            get()
            {
                return this.val
            },
            set(targetGroupName)
            {
                this.val = targetGroupName
            }
        }
    },
    watch: {
        targetGroupName(newVal) {
            this.val = newVal
        }
    },
    created() {
        this.reloadForm()
    },
    methods: {
        async updateTargetGroup(){
            this.$refs.form.validate()
            if(this.valid){
                this.loading = true
                var alertType = ''
                var alertMsg = ''
                try {
                    let data = {
                        data: {
                            type: "target-groups", 
                            id: this.targetGroupId,
                            attributes: {
                                name: this.name.trim()
                            },
                            relationships: {
                                space: {
                                    data: {
                                        type: "spaces",
                                        id: this.spaceId
                                    }
                                }
                            }
                        }
                    };
                    const response = await updateTargetGroup(this.targetGroupId, data)

                    if(response.status == 200) {
                        //this.alertValue = true
                        alertMsg =  i18n.t('editTargetGroupSuccess')
                        alertType = 'success'
                        this.$emit('proceedSubmit', alertMsg, alertType, this.name, this.targetGroupIndex)
                        this.reloadForm()
                    }
                } catch (e) {
                    if(e.response){
                        this.alertValue = true
                         if (e.response.status == 422 ){
                            for(let i = 0; i < e.response.data.errors.length; i++){
                                if(e.response.data.errors[i].detail == 'The name has already been taken.'){
                                    this.alertType = 'error'
                                    this.alertMsg =  i18n.t('editTargetGroupNameAlreadyTaken')
                                }
                                else {
                                    alertType = 'error'
                                    alertMsg =  i18n.t('serverError')
                                    this.$emit('proceedSubmit', alertMsg, alertType, this.name, this.targetGroupIndex)
                                    this.reloadForm()
                                }
                            }
                        } else if(e.response.status == 403) {
                            alertType = 'error'
                            alertMsg =  i18n.t('forbidden')
                            this.$emit('proceedSubmit', alertMsg, alertType, this.name, this.targetGroupIndex)
                            this.reloadForm()
                        } else{
                            alertType = 'error'
                            alertMsg =  i18n.t('serverError')
                            this.$emit('proceedSubmit', alertMsg, alertType, this.name, this.targetGroupIndex)
                            this.reloadForm()
                        }
                    }
                }
                this.loading = false
            }
        },
        reloadForm(){
            this.dialog = false,
            this.alertMsg = '',
            this.name = this.targetGroupName
        },
        onDialogClose(){
            this.reloadForm(),
            this.$emit('closeMenu', this.targetGroupIndex)
        }
    }
}
</script>